<template>
  <div>
    <b-container>

      <b-row>
        <b-col>
          <div class="mt-4 d-flex align-items-start justify-content-between">
            <div class="d-flex align-items-start">
              <div>
                <back-arrow />
              </div>
              <div>
                <h1 class="page-title">Notes pour hospitalisation</h1>
                <h2 class="page-subtitle">Total : {{ notes.length }}</h2>
              </div>
            </div>
            <b-button variant="primary" @click="clickOnCreateBtn">
              <plus-icon size="18" class="mr-1" /> Ajouter note
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="notes.length === 0" class="mt-4">
        <b-col>
          <b-card>
            Aucune note pour cette hospitalisation.
          </b-card>
        </b-col>
      </b-row>

      <b-row v-else>

        <b-card-group columns>

          <b-card class="mt-2 mb-4 shadow-sm" v-for="note in notes" :key="note.id">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <h4 class="card-title">{{ note.title }}</h4>
                <h6 class="card-subtitle text-muted mb-2">{{ note.creationDateToString }}</h6>
              </div>
              <div>
                <card-actions
                  :itemId="note.id"
                  @clickOnEditBtn="clickOnEditBtn"
                  @clickOnDeleteBtn="clickOnDeleteBtn"
                ></card-actions>
              </div>
            </div>

            <div class="multiline" v-if="note.description">
              {{note.description}}
            </div>

            <div v-if="note.fileName != null">

              <b-card
                v-if="note.isPhoto && imageSrcMap[note.id]"
                class="mt-2"
                @click="zoomOnImage(imageSrcMap[note.id])"
                :img-src="imageSrcMap[note.id]"
                img-alt="Aperçu"
              >
              </b-card>

              <b-embed
                v-if="note.isVideo && videoSrcMap[note.id]"
                class="mt-2"
                type="video"
                aspect="16by9"
                controls
              >
                <source :src="videoSrcMap[note.id]">
              </b-embed>
            </div>

          </b-card>

        </b-card-group>

      </b-row>
    </b-container>

    <!-- Modal Delete -->
    <note-delete-modal :selected="ui.selected" @didDeleteNote="didDeleteNote()"></note-delete-modal>

    <!-- Modal Zoom on image -->
    <zoom-on-image v-if="ui.zoomOnImageSrc !== null" :src="ui.zoomOnImageSrc" @didCloseZoomOnImage="didCloseZoomOnImage"></zoom-on-image>
  </div>

</template>

<script>

import api from "../../services/api";
import BackArrow from "../../components/BackArrow";
import CardActions from "../../components/CardActions";
import NoteDeleteModal from "./NoteDeleteModal";
import ZoomOnImage from "../../components/ZoomOnImage";

export default {

  name: 'NoteForHospitalization',

  components: {
    BackArrow,
    CardActions,
    NoteDeleteModal,
    ZoomOnImage
  },

  data() {
    return {
      hospitalizationId: this.$route.params.hospitalizationId,
      notes: [],
      imageSrcMap: {},
      videoSrcMap: {},
      ui: {
        selected: null,
        zoomOnImageSrc: null
      }
    }
  },

  mounted() {
    this.fetchNotes()
  },

  methods: {

    async fetchNotes(){
      try {
        const response = await api.get(`/note/getNotesByHospitalization?hospitalizationId=${this.hospitalizationId}`)
        this.notes = response.data

        for (const note of this.notes) {
          if (note.fileName && note.fileUrl) {
            if (note.isPhoto) {
              await this.loadMediaPreview(note.id, note.fileUrl, true)
            } else if (note.isVideo) {
              await this.loadMediaPreview(note.id, note.fileUrl, false)
            }
          }
        }
      } catch (e) {
        console.error('fetchNotes error', e)
      }
    },

    async loadMediaPreview(noteId, fileUrl, isPhoto) {
      try {
        const res = await api.get(fileUrl, {
          responseType: 'blob'
        })

        const ct = (res.headers && res.headers['content-type']) || ''

        if (isPhoto && !ct.startsWith('image/')) {
          throw new Error('La réponse n\'est pas une image (content-type=' + ct + ')')
        }

        const blobUrl = window.URL.createObjectURL(res.data)

        if (isPhoto) {
          this.$set(this.imageSrcMap, noteId, blobUrl)
        } else {
          this.$set(this.videoSrcMap, noteId, blobUrl)
        }
      } catch (e) {
        console.error('loadMediaPreview error', e)
      }
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'NoteCreate',
        params: {
          hospitalizationId: this.hospitalizationId
        }
      })
    },

    clickOnEditBtn(id) {
      this.$router.push({
        name: 'NoteEdit',
        params: {
          noteId: id,
          hospitalizationId: this.hospitalizationId
        }
      })
    },

    clickOnDeleteBtn(id) {
      this.ui.selected = this.notes.find((note) => note.id === id)
      this.$bvModal.show('note-delete-modal')
    },

    didDeleteNote() {
      this.ui.selected = null
      this.fetchNotes()
    },

    zoomOnImage(imageSrc) {
      this.ui.zoomOnImageSrc = imageSrc
    },

    didCloseZoomOnImage() {
      this.ui.zoomOnImageSrc = null
    }
  },

  beforeDestroy() {
    Object.values(this.imageSrcMap).forEach(url => {
      window.URL.revokeObjectURL(url)
    })
    Object.values(this.videoSrcMap).forEach(url => {
      window.URL.revokeObjectURL(url)
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/note/NoteForHospitalization.vue